export const all_routes = {
  dealsDashboard: "/dashboard/deals-dashboard",
  dashboard: "/dashboard",
  linkusClient: "/linkus-client",
  agentLinkusClient: "/agent/linkus-client",
  scriptGenerator: "/script-generator",
  adminDashboard: "/admin/dashboard",
  adminDevices: "/admin/devices",
  deviceDetails: "/admin/device-details",
  suspendedCompaniesList: "/admin/suspended-companies-list",
  contactDetails: "/crm/customer-details",
  agentContactDetails: "/agent/crm/customer-details",
  companyDetails: "/crm/company-details",
  deals: "/crm/deals",
  dealsDetails: "/crm/deals-details",
  dealsKanban: "/crm/deals-kanban",
  contactList: "/crm/customer-list",
  agentContactList: "/agent/crm/customer-list",
  leadsKanban: "/leads-kanban",
  pipeline: "/crm/pipeline",
  contactFaq: "/crm/contactFaq",
  allCalls: "/crm/speakToLead/allCalls",
  api: "/crm/api",
  security: "/crm/setting/security",
  agentSecurity: "/agent/crm/setting/security",
  adminSecurity: "/admin/crm/setting/security",
   templates: "/templates",
   groups: "/groups",
   agentGroups: "agent/groups",
   whatsapp: "/whatsapp",
   whatsappHistory: "/whatsapp/history",
   wabaTemplates: "/whatsapp/templates",
   wabaCampaigns: "/whatsapp/campaigns",
   wabaAddCampaign: "/whatsapp/campaign/add",
   wabaAddTemplate: "/whatsapp/template/add",
   wabaCampaignDetails: "/whatsapp/campaign/details",
    agentWhatsapp: "/agent/whatsapp",
   agentWhatsappHistory: "/agent/whatsapp/history",
   agentWabaTemplates: "/agent/whatsapp/templates",
   agentWabaCampaigns: "/agent/whatsapp/campaigns",
   agentWabaAddCampaign: "/agent/whatsapp/campaign/add",
   agentWabaAddTemplate: "/agent/whatsapp/template/add",
   agentWabaCampaignDetails: "/agent/whatsapp/campaign/details",
   wabaSetting: "/whatsapp/setting",
   wabaAutomation: "/whatsapp/automation",
   wabaFlowBuilder: "/whatsapp/automation/flows/:id",
   wabaFlowBuilderNew: "/whatsapp/automation/flows/new",
   wabaMetaFlows: "/whatsapp/meta-flows",
  callAndRecording: "/agent/crm/call-logs-and-recordings",
  agentCallAndRecording: "/agent/crm/agent-call-logs-and-recordings",
  syncAndIntegration: "/crm/sync-and-integration",
  agentSyncAndIntegration: "/agent/crm/sync-and-integration",
  pipedriveCallback: "/pipedrive/callback",
  importAndExport: "/crm/import-and-export",
  agentImportAndExport: "/agent/crm/import-and-export",
  helpAndSupport: "/crm/help-and-support",
  agentHelpAndSupport: "/agent/crm/help-and-support",
  myTickets: "/crm/help-and-support/myTickets",
  myTicketsAgent: "/agent/crm/help-and-support/myTickets",
  upgradePlan: "/crm/upgradePlan",
  billing: "/crm/billing",
  credits: "/crm/credits",
  adminPlans: "/admin/plans",
  adminCoupons: "/admin/coupons",
  adminDirectNotification: "/admin/notifications/direct",
  adminEmailNotification: "/admin/notifications/email",
  adminWhatsappCampaigns: "/admin/whatsapp/campaigns",
  adminWhatsappAddCampaign: "/admin/whatsapp/add-campaign",
  adminWhatsappCampaignDetails: "/admin/whatsapp/campaign-details",
  adminWhatsappChat: "/admin/whatsapp/chat",
  adminWhatsappHistory: "/admin/whatsapp/history",
  adminWhatsappTemplates: "/admin/whatsapp/templates",
  adminWhatsappAddTemplate: "/admin/whatsapp/template/add",
  adminWhatsappSetting: "/admin/whatsapp/setting",
  calendar: "/crm/calendar",
  agentCalendar: "/agent/crm/calendar",
  agentDashboard: "/agent/dashboard",
  contactGrid: "/crm/customer-kanban",
  leadsDetails: "/leads-details",
  agentLeadsDetails: "/agent/leads-details",
  contact_statuses: "/contact-statuses",
  leads: "/leads",
  agentFaq: "/agent/contactFaq",
  agentLeads: "/agent/leads",
  Whatsapp: "/crm/Whatsapp",
  register: "/register",
  linkLogin: "/link-login",
  forgotPassword: "/forgot-password",
  userVerification: "/user-verification",
  copyMagicLink: "/copy-magic-link",
  agentSetup: "/agent-setup",
  resetPassword: "/reset-password",
  profile: "/crm/settings/profile",
  callerSettings: "/crm/settings/dialer",
  agentProfile: "/agent/settings/profile",
  agentCallerSettings: "/agent/settings/dialer",
  adminProfile: "/admin/settings/profile",
  agents: "/agents",
  contactReports: "/reports/contact-reports",

  adminCompaniesList: "/admin/companies-list",
  manageTickets: "/admin/manage-tickets",
  adminApiLogs: "/admin/api-logs",
  adminUserSessions: "/admin/user-sessions",
  adminUserActivity: "/admin/user-activity",

  // DIDLogic — Phone Numbers & Calling
  didBrowseNumbers: "/numbers/browse-numbers",
  didNumberCart:    "/numbers/number-cart",
  didMyNumbers: "/numbers/my-numbers",
  didAssignNumbers: "/numbers/assign-numbers",
  didCallHistory: "/numbers/call-history",
  didKycDocuments: "/numbers/kyc-documents",
  adminDidNumbers: "/admin/numbers/numbers",
  adminDidSettings: "/admin/numbers/settings",
  callRates:        "/numbers/call-rates",
  adminCallRates:   "/admin/numbers/call-rates",

  // Power Dialer
  powerDialer: "/power-dialer",
  powerDialerLists: "/power-dialer/lists",
  agentPowerDialer: "/agent/power-dialer",
  agentPowerDialerLists: "/agent/power-dialer/lists",

  adminSystemEmails: "/admin/system-emails",
  adminBilling: "/admin/billing",
};
